import {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'
import MultiSelect from '@adv-mt/mt-form-filter-multi-select'

const LEGACY_WRAPPER = 'legacy'

function FormEquipment({
  initialSearch = {},
  onChange,
  overlayContentRef,
  placeholder,
  type,
  value = [],
  withLabel = true,
  wrapper = LEGACY_WRAPPER
}) {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {equipments: equipmentsConfig, FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const currentPlaceholder = placeholder || i18n.t('COMMON_ALL_EQUIPMENTS')

  const valueIds = value.map(equipmentLabel => equipmentsConfig.find(({label}) => label === equipmentLabel)?.id)

  const handleOnChange = (_, {value}) => {
    const equipments = Array.isArray(value) ? value : [value]
    const equipmentInitialSearch = initialSearch[FILTER_NAMES.EQUIPMENTS]
    const equipmentsLabels = equipments.map(equipmentId => equipmentsConfig.find(({id}) => id === equipmentId)?.label)

    const hasLastFilter = equipmentInitialSearch?.every(equipment => equipmentsLabels.includes(equipment))

    onChange(_, {
      field: FILTER_NAMES.EQUIPMENTS,
      value: equipmentsLabels,
      lastFilter: hasLastFilter && TRACKING_FILTER_NAMES[FILTER_NAMES.EQUIPMENTS]
    })
  }

  const getValueEquipmentSelected = () => {
    return value.reduce((acc, value) => {
      const equipmentSelected = equipmentsConfig.find(equipment => equipment.label === value)
      if (equipmentSelected) {
        acc.push(equipmentSelected?.id)
      }
      return acc
    }, [])
  }

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <MultiSelect
        field={FILTER_NAMES.EQUIPMENTS}
        initialSearch={initialSearch}
        label={i18n.t('COMMON.EQUIPMENT.LABEL')}
        onChange={handleOnChange}
        options={equipmentsConfig}
        placeholder={currentPlaceholder}
        value={valueIds}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          allSelectionsLabel: i18n.t('COMMON.ALL'),
          label: i18n.t('COMMON.EQUIPMENT.LABEL'),
          name: FILTER_NAMES.EQUIPMENTS,
          options: equipmentsConfig,
          type
        }
      ]}
      group={`${FILTER_NAMES.EQUIPMENTS}Group`}
      legend={i18n.t('COMMON.EQUIPMENT.LABEL')}
      onChange={({value}) => {
        handleOnChange(null, {value: value.filter(id => id !== allSelectionsId)})
      }}
      overlayContentRef={overlayContentRef}
      placeholder={value.length ? value?.join(', ') : i18n.t('COMMON.ALL')}
      showLegend={withLabel}
      value={{[FILTER_NAMES.EQUIPMENTS]: value.length ? getValueEquipmentSelected() : [allSelectionsId]}}
      wrapper={wrapper}
    />
  )
}

FormEquipment.displayName = 'FormEquipment'
FormEquipment.propTypes = {
  initialSearch: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

const MemoFormEquipment = memo(FormEquipment)
MemoFormEquipment.displayName = 'FormEquipment'
export default MemoFormEquipment
